import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NavbarControlComponent } from '../../shared/controls/navbar-control/navbar-control.component';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-terms',
    imports: [FontAwesomeModule, NavbarControlComponent],
    templateUrl: './terms.component.html',
    styleUrl: './terms.component.scss'
})
export class TermsComponent implements OnInit {

    public terms: string = null!;
    constructor(private titleService: Title,
        private _translateService: TranslateService,
        private _http: HttpClient,
    ) { }

    public ngOnInit(): void {
        let lang = this._translateService.currentLang || 'en';

        this._http.get<any>('./assets/i18n/static-content/terms.json')
            .subscribe({
                next: res => {
                    this.terms = res[lang]?.['terms'];
                }
            });

        this.titleService.setTitle('ClockFlex - Terms of Use');
    }
}
